import Button from "@mui/material/Button";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from "@mui/material/Typography";

import React, {useEffect, useState} from "react";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import HeaderBar from "../components/HeaderBar";
import {jwtDecode} from "jwt-decode";
import Link from "@mui/material/Link";
import WarrantyPolicy from "../files/RCP RGA Warrany _ Return Goods Policy rev 3.pdf";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

function ViewUserRGA() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { state } = useLocation();
  const { rga_number } = state;
  const [claimNum, setClaimNum] = useState(-1);
  const [companyName, setCompanyName] = useState("");
  const [custContactFirstName, setCustContactFirstName] = useState("");
  const [custContactLastName, setCustContactLastName] = useState("");
  const [custClaimNum, setCustClaimNum] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNum, setPhoneNum] = useState("");
  const [status, setStatus] = useState(-1);
  const [statusString, setStatusString] = useState("");

  const [rcpPN, setRcpPN] = useState("");
  const [custPN, setCustPN] = useState("");
  const [custReturnCompName, setCustReturnCompName] = useState("");
  const [custReturnName, setCustReturnName] = useState("");
  const [custReturnAddr, setCustReturnAddr] = useState("");
  const [custReturnAddr2, setCustReturnAddr2] = useState("");
  const [custReturnCity, setCustReturnCity] = useState("");
  const [custReturnState, setCustReturnState] = useState("");
  const [custReturnZip, setCustReturnZip] = useState("");
  const [custReturnCountry, setCustReturnCountry] = useState("");
  const [purchOrderNum, setPurchOrderNum] = useState("");

  const [quantity, setQuantity] = useState("");
  const [entriesList, setEntriesList] = useState([]);
  const [rgaImageFiles, setRgaImageFiles] = useState([]);
  // const [rgaImages, setRgaImages] = useState([]);

  const [disposition, setDisposition] = useState("");

  const handleDownloadZip = async (event) => {
      await axios.post('/api/getuserrgaimagezips', {
          rga_number: rga_number,
      }, {
          responseType: 'blob',
      }).then(function (response) {
          if (response.status === 200) {
              console.log(response);
              // let zip_file = response.data.zipfile;
              // let filename = response.data.filename;
              let url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/zip'}));
              let link = document.createElement('a');
              link.href = url;
              let filename = rga_number.toString() + '.zip'
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(url);
          }
      }).catch(function (error) {
          console.log(error);
          //setOpenCompleteErrorSnackbar(true);
      });
  }

  useEffect( () => {
      // console.log(rga_number);
      axios.post('/api/viewuserrga', {
              rga_number: rga_number,
          }).then(function (response) {
              // console.log(response);
              if (response.status === 200) {
                  const rga_data = response.data.rga;
                  setClaimNum(rga_data.id);
                  setCompanyName(rga_data.cust_company_name);
                  setCustContactFirstName(rga_data.cust_first_name);
                  setCustContactLastName(rga_data.cust_last_name);
                  setCustClaimNum(rga_data.cust_claim_num);
                  setEmail(rga_data.cust_email);
                  setPhoneNum(rga_data.phone_num);
                  setStatus(rga_data.status);

                  if (rga_data.status === 0) {
                      setStatusString("Pending");
                  }
                  else if (rga_data.status === 1) {
                      setStatusString("Completed");
                      setDisposition(rga_data.disposition);
                  }
                  // else if (rga_data.status === 2) {
                  //     setStatusString("Rejected");
                  //     setDisposition(rga_data.disposition);
                  // }

                  setRcpPN(rga_data.pn);
                  setCustPN(rga_data.cust_pn);
                  setCustReturnCompName(rga_data.cust_ret_comp_name);
                  setCustReturnName(rga_data.cust_ret_name);
                  setCustReturnAddr(rga_data.cust_ret_addr);
                  setCustReturnAddr2(rga_data.cust_ret_addr_2);
                  setCustReturnCity(rga_data.cust_ret_city);
                  setCustReturnState(rga_data.cust_ret_state);
                  setCustReturnZip(rga_data.cust_ret_zip);
                  setCustReturnCountry(rga_data.cust_ret_country);
                  setPurchOrderNum(rga_data.purch_order_num);
                  setQuantity(response.data.quantity);

                  const rga_serial_num_entries = response.data.rga_serial_nums;
                  let new_entries = [];
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>RCP Serial Number(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>Customer Defect Code(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>Production Date(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>In Service Date(s):</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>In Service Hours:</Item>
                      </Grid>);
                  new_entries.push(<Grid item xs={2.4}>
                        <Item>Description(s):</Item>
                      </Grid>);
                  for (let i=0; i<rga_serial_num_entries.length; i++) {
                      const entry = rga_serial_num_entries[i];
                      // Add Code to make Grid items for each dictionary
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.serial_num}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.defect_code}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.prod_date}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.in_serv_date}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.in_serv_hours}</Item>
                          </Grid>);
                      new_entries.push(<Grid item xs={2.4}>
                            <Item>{entry.desc}</Item>
                          </Grid>);
                  }
                  setEntriesList(new_entries);
                  // Modify to accept the single zip file as a link
                  let filenames = response.data.filenames;
                  let temp_links = [];
                  for (let i=0; i<filenames.length; i++) {
                      temp_links.push(<Button component={Link} onClick={handleDownloadZip}>{filenames[i]}</Button>)
                  }
                  setRgaImageFiles(temp_links);
                  // let images = response.data.images;
                  // let filenames = response.data.filenames;
                  // let temp_imgs = [];
                  // for (let i=0; i<images.length; i++) {
                  //     // console.log(filenames[i]);
                  //     const filename = filenames[i];
                  //     const filename_arr = filename.split(".");
                  //     const extension = filename_arr[filename_arr.length - 1];
                  //     if (extension === "jpg") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/jpg;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  //     else if (extension === "jpeg") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/jpeg;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  //     else if (extension === "png") {
                  //         const image = new Image();
                  //         image.title = filename
                  //         image.src = 'data:image/png;base64,' + images[i];
                  //         temp_imgs.push(image);
                  //     }
                  // }
                  // setRgaImages(temp_imgs);
              }
          })
          .catch(function (error) {
              console.log(error);
          });
  }, []);

  // useEffect(() => {
  //     console.log(rga_number);
  //     axios.post('/api/viewrgaimages', {
  //             rga_number: rga_number,
  //         }).then(function (response) {
  //             console.log(response);
  //             let images = response.data.images;
  //             let filenames = response.data.filenames;
  //             let temp_imgs = [];
  //             for (let i=0; i<images.length; i++) {
  //                 console.log(filenames[i]);
  //                 const filename = filenames[i];
  //                 const filename_arr = filename.split(".");
  //                 const extension = filename_arr[filename_arr.length - 1];
  //                 console.log(filename);
  //                 console.log(filename_arr);
  //                 console.log(extension);
  //                 if (extension === "jpg") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/jpg;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //                 else if (extension === "jpeg") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/jpeg;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //                 else if (extension === "png") {
  //                     const image = new Image();
  //                     image.title = filename
  //                     image.src = 'data:image/png;base64,' + images[i];
  //                     temp_imgs.push(image);
  //                 }
  //             }
  //             setRgaImages(temp_imgs);
  //         })
  //         .catch(function (error) {
  //             console.log(error);
  //         });
  // }, []);

  return (
      <Box>
          <HeaderBar />
          <Stack direction='column' spacing={2}>
              <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h4" gutterBottom> RGA: #{rga_number}</Typography>
              </Box>
              <Stack spacing={2}>
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      Status: {statusString}
                  </Box>
                  {status === 0 ? "" :
                  <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      Disposition: {disposition}
                  </Box>}
              </Stack>
              <Card>
                  <CardHeader title="Company Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>Company Claim Number: {custClaimNum}</Item>
                          <Item>Company Name: {companyName}</Item>
                          <Item>First Name: {custContactFirstName}</Item>
                          <Item>Last Name: {custContactLastName}</Item>
                          <Item>Phone Number: {phoneNum}</Item>
                          <Item>Email: {email}</Item>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Return Shipping Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>Company Name: {custReturnCompName}</Item>
                          <Item>Full Name: {custReturnName}</Item>
                          <Item>Address: {custReturnAddr}</Item>
                          <Item>Address 2: {custReturnAddr2}</Item>
                          <Item>City: {custReturnCity}</Item>
                          <Item>State: {custReturnState}</Item>
                          <Item>Zip: {custReturnZip}</Item>
                          <Item>Country: {custReturnCountry}</Item>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Product Information:"></CardHeader>
                  <CardContent>
                      <Stack spacing={3}>
                          <Item>RCP PN: {rcpPN}</Item>
                          <Item>Customer PN: {custPN}</Item>
                          <Item>Purchase Order Number: {purchOrderNum}</Item>
                          <Item>Quantity: {quantity}</Item>
                          <Grid container direction="row" alignContent="center" alignItems="center" spacing={1}>
                              {entriesList.length > 0 && entriesList.map(
                                      (text_item) => text_item)}
                          </Grid>
                      </Stack>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Photos:"></CardHeader>
                  <CardContent>
                      {rgaImageFiles.map((rgaImageFile) => (
                          <Box>{rgaImageFile}</Box>
                      ))}
                    {/*  <ImageList sx={{ width: 500, height: 450 }} cols={3} rowHeight={164}>*/}
                    {/*      {rgaImages.map((rgaImage) => (*/}
                    {/*        <ImageListItem key={rgaImage.src}>*/}
                    {/*          <img*/}
                    {/*            srcSet={rgaImage.src}*/}
                    {/*            src={rgaImage.src}*/}
                    {/*            alt={rgaImage.title}*/}
                    {/*            loading="lazy"*/}
                    {/*          />*/}
                    {/*    </ImageListItem>))}*/}
                    {/*</ImageList>*/}
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Warranty Policy"></CardHeader>
                  <CardContent>
                      <Link href={WarrantyPolicy} target="_blank" download="RCP RGA Warrany _ Return Goods Policy rev 3.pdf">Warranty Policy</Link>
                  </CardContent>
              </Card>
              <Card>
                  <CardHeader title="Return Shipping Information"></CardHeader>
                  <CardContent>
                      <Box>
                          <p>
                          Richardson Cooling Packages, LLC
                          <br/> 1900 New Butler Road
                          <br/> New Castle, PA 16101
                          <br/> <br/> UPS Account #: Y97365
                          <br/> R&L Carriers Account #: SRF731
                          </p>
                      </Box>
                  </CardContent>
              </Card>
          </Stack>
      </Box>
  );
}

export default ViewUserRGA;